export enum TermType {
  FullySpecifiedName,
  Synonym,
  Abbreviation
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/TermType.ts